export default function product() {

  /*
  document.querySelectorAll('.tabarea').forEach(root => {
    if (root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    const tabs    = root.querySelector('.tabs');
    const buttons = root.querySelectorAll('.tab-button');
    const panels  = root.querySelectorAll('.tab-panel');

    // 初期状態：すべて閉
    panels.forEach(p => {
      p.style.height = '0px';
      p.style.opacity = '0';
      p.classList.remove('open');
    });

    // 🔽 初期値：最初のタブとパネルを開く
    const initialButton = buttons[0];
    const initialPanel  = root.querySelector('#' + initialButton.dataset.target);

    initialButton.classList.add('active');
    initialPanel.classList.add('open');
    initialPanel.style.opacity = '1';
    initialPanel.style.height = initialPanel.scrollHeight + 'px';

    // 👇 通常のタブ切り替え処理
    tabs.addEventListener('click', (e) => {
      const btn = e.target.closest('.tab-button');
      if (!btn) return;

      const targetId     = btn.dataset.target;
      const targetPanel  = root.querySelector('#' + targetId);
      const targetIsOpen = targetPanel.classList.contains('open');

      buttons.forEach(b => b.classList.toggle('active', b === btn && !targetIsOpen));

      panels.forEach(panel => {
        if (panel === targetPanel) {
          targetIsOpen ? closePanel(panel) : openPanel(panel);
        } else {
          closePanel(panel);
        }
      });
    });
  });
}

function openPanel(panel) {
  // いったんpx固定 → 目標高さへ
  const target = panel.scrollHeight;
  // 開く準備（現在0px想定だが、保険としてreflow）
  panel.style.height = panel.offsetHeight + 'px';
  // reflow強制
  panel.offsetHeight;

  panel.classList.add('open');
  panel.style.opacity = '1';
  panel.style.height = target + 'px';

  const onEnd = (e) => {
    if (e.propertyName !== 'height') return; // heightの終端だけ拾う
    panel.style.height = 'auto';             // 自然な伸縮へ
    panel.removeEventListener('transitionend', onEnd);
  };
  panel.addEventListener('transitionend', onEnd);
}

function closePanel(panel) {
  // auto→pxに固定してから0へ
  const current = panel.scrollHeight;
  panel.style.height = current + 'px';
  // reflow
  panel.offsetHeight;

  panel.classList.remove('open');
  panel.style.opacity = '0';
  panel.style.height = '0px';
  */
}
